/* eslint-disable react/no-unknown-property */
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { CSSTransition } from 'react-transition-group';
import { useHistory } from 'react-router-dom';
import { VFlex, Flex } from './Flex';
import { store } from '../mobx/store';
import { Divider } from './Divider';
import { themeStore } from '../mobx/theme-store';


const MenuText = styled.div`
  font-family: 'Noto Sans TC';
  font-size: 14px;
  font-weight: 300;
  line-height: 17.5px;
  letter-spacing: 0.42px;
`;

const MenuHeader = styled.div`
  color: ${themeStore.colors.NEUTRAL[900]};
  font-family: 'Noto Sans TC';
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  letter-spacing: 0.42px;
`;

const AccordionContainer = styled.div`
  width: 90%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 100%;
  overflow-y: auto; 
`;

const AccordionItem = styled.div`
  margin-bottom: 10px;
`;

const AccordionHeader = styled.div`
  padding: 10px;
  display: flex;
  gap: 20px;
  align-items: center;
  color: ${themeStore.colors.NEUTRAL[900]};
  font-family: 'Noto Sans TC';
`;

const StyledList = styled.ul`
  display: flex;
  gap: 8px;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 17px;
`;

const StyledMenuList = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-top: 17px;
`;

const AccordionContent = styled.div`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  padding: 10px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const DayKarkalText = styled.span`
  font-family: 'Saudagar';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.5px;
  letter-spacing: 0.42px;
`;

const VFlexContainer = styled(VFlex)`
  width: 100%;
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(5px); /* Standard backdrop-filter property */
  -webkit-backdrop-filter: blur(5px); /* Webkit-specific backdrop-filter property for Chrome */
  align-items: center;
  padding-bottom: 30px;
  height: 100%;
`;

const MENU_LIST = [
  {
    title: '鑽石',
    image: '/images/menu-icons/diamond-menu-icon.svg',
    items: [
      {
        title: '天然鑽石',
        url: '/diamonds',
      },
      {
        title: '實驗室培育鑽石',
        url: '/diamonds?t=igi',
      },
      {
        title: '實驗室培育彩色鑽石',
        url: '/diamonds?t=fancy-diamonds',
      },
    ],
  },
  {
    title: '婚戒系列',
    image: '/images/menu-icons/ring-menu-icon.svg',
    items: [
      {
        title: '求婚戒指',
        url: '/engagement',
      },
      {
        title: '結婚對戒',
        url: '/weddings',
      },
    ],
  },
  {
    title: '黃金系列',
    image: '/images/menu-icons/gold-menu-icon.svg',
    items: [
      {
        title: '黃金報價',
        url: '/gold-price',
      },
    ],
  },
  {
    title: '時尚系列',
    image: '/images/menu-icons/fashion-menu-icon.svg',
    items: [
      {
        title: '戒指',
        url: '/fashion/rings',
      },
      {
        title: '手鐲/手鏈',
        url: '/fashion/bracelets',
      },
      {
        title: '吊墜',
        url: '/fashion/pendants',
      },
      {
        title: '項鏈',
        url: '/fashion/necklaces',
      },
      {
        title: '耳環',
        url: '/fashion/earrings',
      },
    ],
  },
  {
    title: '珠寶訂製',
    image: '/images/menu-icons/bespoke-menu-icon.svg',
    noDropDown: true,
    url: '/bespoke',
    items: [
      {
        title: '珠寶訂製',
        url: '/bespoke',
      },
    ],
  },
  {
    title: '知識庫',
    image: '',
    noImage: true,
    noDropDown: true,
    url: '/diamond-knowledge',
    items: [
    ],
  },
  {
    title: '客戶專區',
    image: '',
    noImage: true,
    items: [
      {
        title: '售後服務',
        url: '/customers-service',
      },
      {
        title: '訂單狀態',
        url: '/order-status',
      },
    ],
  },
  {
    title: (
      <span>
        關於
        {' '}
        <DayKarkalText>DAY KARKAL</DayKarkalText>
      </span>
    ),
    image: '',
    noImage: true,
    items: [
      {
        title: '關於我們',
        url: '/aboutus',
      },
      {
        title: '聯絡我們',
        url: '/contactus',
      },
      {
        title: '條款及細則',
        url: '/terms-and-conditions',
      },
      {
        title: '私隱條例',
        url: '/privacypolicy',
      },
    ],
  },
];

const Accordion = ({ items }) => {
  const history = useHistory();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    if (items[index].noDropDown) {
      // If noDropDown is true, navigate to the specified URL
      history.push(items[index].url);
      store.isShowOverlay = false;
    } else if (index === openIndex) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <AccordionContainer>
      {items.map((item, index) => (
        <AccordionItem>
          <AccordionHeader onClick={() => toggleAccordion(index)}>
            {!item.noImage && <img src={item.image} alt="menu-icon" width="20px" height="20px" />}
            <Wrapper>
              <MenuHeader>
                {item.title}
              </MenuHeader>
              {!item.noDropDown && (
                <img
                  style={{
                    width: '10px',
                    height: '10px',
                    transform: index !== openIndex ? 'rotate(90deg)' : 'rotate(270deg)',
                    transition: 'all 0.3s',
                  }}
                  src="/images/right-arrow.png"
                  alt="drop-down-icon"
                />
              )}
            </Wrapper>
          </AccordionHeader>
          <AccordionContent isOpen={index === openIndex}>
            {!item.noImage ? (
              <StyledList>
                {item.items.map(subItem => (
                  <MenuText key={subItem.title}>
                    <a href={subItem.url}>{subItem.title}</a>
                  </MenuText>
                ))}
              </StyledList>
            ) : (
              <StyledMenuList>
                {item.items.map(subItem => (
                  <MenuText key={subItem.title}>
                    <a href={subItem.url}>{subItem.title}</a>
                  </MenuText>
                ))}
              </StyledMenuList>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </AccordionContainer>
  );
};

export const HamburgerOverlay = observer(() => {
  useEffect(() => {
    if (store.isShowOverlay) {
      document.body.classList.add('lock-scroll');
    } else {
      document.body.classList.remove('lock-scroll');
    }
  });

  const history = useHistory();
  const CloseButton = styled(Flex)`
    justify-Content: space-between;
    align-Items: center;
    align-Self: stretch;
    margin-bottom: 80px;

    .closebtn {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 32px;
      height: 32px;
      opacity: 0.3;
    }
    .closebtn:hover {
      opacity: 1;
    }
    .closebtn:before, .closebtn:after {
      position: absolute;
      left: 15px;
      content: ' ';
      height: 33px;
      width: 2px;
      background-color: #121211;
    }
    .closebtn:before {
      transform: rotate(45deg);
    }
    .closebtn:after {
      transform: rotate(-45deg);
    }
  `;

  return (
    <CSSTransition
      in={store.isShowOverlay}
      timeout={300}
      classNames="page"
      unmountOnExit
    >
      <div
        classNames="page"
        style={{
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 40,
          right: 0,
          zIndex: 9999,
        }}
        onClick={(event) => {
          // Check if the click target is the close button or its child elements
          if (
            event.target.classList.contains('closebtn')
            || event.target.closest('.closebtn')
          ) {
            store.isShowOverlay = false;
          }
        }}
      >
        <VFlexContainer>
          <CloseButton>
            <div
              className="simple-btn closebtn"
              onClick={() => {
                store.isShowOverlay = false;
              }}
            />
          </CloseButton>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '85%', marginBottom: '20px' }}>
            <MenuHeader
              style={{ display: 'flex', gap: '8px', width: '100%', alignItems: 'center' }}
              onClick={() => {
                history.push('/cart');
                store.isShowOverlay = false;
              }}
            >
              <img src="/images/menu-icons/cart-menu-icon.svg" alt="booking-menu-icon" />
              購物車
            </MenuHeader>
            <MenuHeader
              style={{ display: 'flex', gap: '8px', width: '100%', alignItems: 'center' }}
              onClick={() => {
                history.push('/booking');
                store.isShowOverlay = false;
              }}
            >
              <img src="/images/menu-icons/booking-menu-icon.svg" alt="booking-menu-icon" />
              預約到訪
            </MenuHeader>
          </div>
          <Divider
            style={{
              width: '90%',
              background: '#CECDCB',
            }}
          />
          <Accordion items={MENU_LIST} />
        </VFlexContainer>
      </div>
    </CSSTransition>
  );
});
